import { Tab } from '@mui/material';

import { a11yProps } from '@/shared';
import { FormTabsOnly } from '@/shared/components/ui';

export type ClientesFibraFormTabsOnlyProps = {
  valueTab: number;
  handleMethodChange: (_event: any, value: any) => void;
};

const ClientesFibraFormTabsOnly: React.FC<ClientesFibraFormTabsOnlyProps> = ({
  handleMethodChange,
  valueTab,
}) => {
  return (
    <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
      <Tab label="RESUMEN" value={1} {...a11yProps(1)} />
      <Tab label="SERVICIOS E INSTALACIÓN" value={2} {...a11yProps(2)} />
      <Tab label="DOCUMENTOS" value={5} {...a11yProps(5)} />
      <Tab label="DATOS ENCUESTA" value={6} {...a11yProps(6)} />
      <Tab label="LOGS" value={7} {...a11yProps(7)} />
      <Tab label="PROMOCIONES" value={8} {...a11yProps(8)} />
    </FormTabsOnly>
  );
};

export default ClientesFibraFormTabsOnly;
